import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import AOS from "aos";
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import TourListing from "./Common/MaldiveTourList"
import { getMaldiveTourFilters, stoteMaldiveTourDetailsUpdate, getMaldiveTourListMore, getMaldiveTourList } from "../Actions/MaldiveTourAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        maldiveTourLists: state.MaldiveTourList
    }
}

const mapDispatchToProps = dispatch => ({
    getMaldiveTourFilters: () => dispatch(getMaldiveTourFilters()),
    stoteMaldiveTourDetailsUpdate: (bool) => dispatch(stoteMaldiveTourDetailsUpdate(bool)),
    getMaldiveTourList: (search, type, rate, price) => dispatch(getMaldiveTourList(search, type, rate, price)),
    getMaldiveTourListMore: (search, type, rate, price, id, loader) => dispatch(getMaldiveTourListMore(search, type, rate, price, id, loader))
});


function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + tour.permalink
            break;

        case "Maldive tour":
            var type = tour.type_id == 1 ? "resorts/" : "packages/"
            url = "/maldives/" + type + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.listing_image != undefined && tour.listing_image != '' ? tour.listing_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        default:
            break;
    }
    return image
}

class MaldiveListingPage extends Component {

    constructor(props) {
        super(props);

        var typingTimer = null;

        this.state = {
            page: 1,
            slider_value: 1,
            rating: "",
            duration: "",
            tour_type: "",
            search_key: ""
        }
        this.props.getMaldiveTourFilters()
    }

    componentDidMount() {

        AOS.init({
            duration: 800,
            once: true
        });

        window.scrollTo(0, 0)
        window.addEventListener("scroll", this.handleScroll)
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        }, () => this.getMaldiveTourList())
    }
    handleClear = (event) => {
        this.setState({
            slider_value: this.props.maldiveTourLists.max_cost,
            rating: "",
            tour_type: "",
            search_key: ""

        }, () => this.getMaldiveTourList())
    }
    componentDidUpdate() {
        if (this.props.maldiveTourLists.update) {
            this.props.stoteMaldiveTourDetailsUpdate(false)
            this.setState({ slider_value: this.props.maldiveTourLists.max_cost })
        }
        if (this.props.maldiveTourLists.toursArray && this.state.refreshData) {
            AOS.refresh();
        }
    }


    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        const scrollTop = window.pageYOffset;
        if (scrollTop > this.state.lastScrollTop && this.props.maldiveTourLists.toursArray) {
            this.fadeUpCards();

            this.setState({ refreshData: true })
        }
        this.setState({ lastScrollTop: scrollTop })
    };


    fadeUpCards = () => {
        var state = this.state
        var id = this.props.maldiveTourLists.tours[this.props.maldiveTourLists.tours.length - 1].id
        this.props.getMaldiveTourListMore(
            state.search_key,
            state.category,
            state.rating,
            state.slider_value,
            id,
            false
        )
    }

    getMaldiveTourList(page) {
        var state = this.state
        this.props.getMaldiveTourList(
            state.search_key,
            state.tour_type,
            state.rating,
            state.slider_value
        )
    }

    handleInputChange = (event) => {

        this.setState({ [event.target.name]: event.target.value })

        clearTimeout(this.typingTimer);

        this.typingTimer = setTimeout(() => {
            this.getMaldiveTourList();
        }, 2500);
    };

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            <div className="page-title">
                <div className="container title-cont">
                    <div className="row">
                        <div className="col-lg-12 title-inner">
                            <div className="breadcrumb-links">
                                <a href="/">Home</a>   <span className="sep"></span> Maldives Tours
                            </div>
                            <h1 id="tour-title">Maldives Tours</h1>
                        </div>
                    </div>
                </div>
            </div>

            <div id="loadDayTour" style={{ backgroundColor: "#f8f8f8" }}>
                <div class="container title-cont filt-bar">

                    <div class="search-form-wrap">
                        <div id="loadSearch">
                            <div class="row">
                                <div className="col-md-10">
                                    <div className="input-group">
                                        <input name="search_key" value={this.state.search_key} onChange={this.handleInputChange} type="text" id="search_key" className="form-control remove-data get-input-length day-ser-bar-m" placeholder="Search for  Destinations, Attractions & Tours" />
                                        <span className="input-group-btn"> </span>
                                    </div>
                                </div>

                                <div class="col-md-2 day-btn-m">
                                    <span class="input-group-btn">
                                        <input class="btn btn-default remove-data" type="reset" value="reset" type="button" onClick={this.handleClear} />
                                    </span>
                                </div>
                            </div>


                        </div>

                    </div>

                    <div class="row" >



                        <div className="col-lg-3 title-inner ">
                            <h5>Rating</h5>
                            <div className="dropdown">
                                <div className="select-drop-arrow"></div>
                                <select className="btn btn-default dropdown-toggle dropdown-pref" id="type" name="rating" value={this.state.rating} onChange={this.handleChange}>
                                    <option value="">All</option>

                                    {this.props.maldiveTourLists.strCounts.length > 0 ? this.props.maldiveTourLists.strCounts.map((start, index) => (
                                        <>{start == 1 ? <option style={{ fontSize: 16, fontWeight: 'lighter' }} value={index + 1}>{Array.from({ length: index + 1 }, () => "★").join("")}</option> : null}</>
                                    )) : null}
                                </select>
                            </div>
                        </div>

                        <div className="col-lg-3 title-inner ">
                            <h5>Type</h5>
                            <div className="dropdown">
                                <div className="select-drop-arrow"></div>
                                <select className="btn btn-default dropdown-toggle dropdown-pref" id="category" name="tour_type" value={this.state.tour_type} onChange={this.handleChange}>
                                    <option data-div="full" value={false} >All</option>
                                    <option value="1" >Resorts</option>
                                    <option value="2" >Packages</option>
                                </select>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <h5 className="text-center">Price Range</h5>
                            <div className="slidecontainer row" style={{ right: "0 !important" }}>
                                <span className="col-md-3" style={{ paddingTop: 5, paddingRight: 0, textAlign: 'right' }}>$ 0.00 </span>
                                <span className="col-md-6" >
                                    <input type="range" min="0" max={this.props.maldiveTourLists.max_cost} value={this.state.slider_value} name="slider_value" onChange={this.handleChange} className="price-slider " id="myRange" />
                                </span>
                                <p className="col-md-3" style={{ paddingTop: 5, paddingLeft: 0 }}>$ <span id="demo"></span>{this.state.slider_value}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div id="myDiv">
                    <div className="maindiv" >
                        <div className="container">
                            <div className="row day-tour-row">
                                {this.props.maldiveTourLists.tours.length > 0 ? this.props.maldiveTourLists.tours.map((tour, index) => (<TourListing
                                    {...this.props}
                                    index={index}
                                    url={getURL(tour)}
                                    bgImage={getBackgroudImage(tour)}
                                    tour={tour}
                                    tourCount={this.props.maldiveTourLists.tours.length}
                                    key={index + 1}
                                />))
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <Footer hyperLink={false} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(MaldiveListingPage);